import fp from 'lodash/fp';
import React from 'react';
import { connect } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, useStripe, useElements } from '@stripe/react-stripe-js';
import {
  branch,
  compose,
  renderNothing,
  setDisplayName,
  wrapDisplayName
} from 'recompose';
import {
  stripeConfigSelector
} from '../../../state/modules/configuration/selectors';

const withStripe = (Component) => {
  const StripeComponent = ({
    Component,
    ...props
  }) => {
    const stripe = useStripe();
    const elements = useElements();
    return (
      <Component {...{ ...props, stripe, elements }}/>
    )
  }

  const WithStripe = ({
    config: {
      publicApiKey
    },
    ...props
  }) => {
    // Create the Stripe object.
    const stripePromise = loadStripe(publicApiKey);

    return (
      <Elements stripe={stripePromise}>
        <StripeComponent Component={Component} {...props} />
      </Elements>
    );
  }

  return (
    process.env.NODE_ENV !== 'production' ?
      setDisplayName(wrapDisplayName(Component, 'withStripe')) :
      fp.identity
  )(WithStripe);
}

export default compose(
  connect((state) => ({
    config: stripeConfigSelector(state)
  })),
  branch(
    ({ config }) => !config,
    renderNothing
  ),
  withStripe,
);



// WEBPACK FOOTER //
// ./src/containers/components/higher-order/with-stripe.js